import React from 'react';
import { Icon, TooltipWrapper } from '@tcc/crate';
import { getMessage } from 'util/locale';

const DeadZoneInfo = () => {
  return (
    <TooltipWrapper
      content={[getMessage('tooltip-text__review-generated-dead-zone')]}
      placement='top'
      alignment='center'
    >
      <div className='vra-dead-zone-info'>
        <Icon glyph={Icon.set.INFO_CIRCLE} />
        <span data-test-id='vra-dead-zone-label'>{getMessage('text__dead-zone-data-issue')}</span>
      </div>
    </TooltipWrapper>
  );             
};

export default DeadZoneInfo;
  